import * as React from 'react';

import { ErrorComponent } from '../../components/base/ErrorComponent';

interface IErrorContainerProps {
  isError?: boolean;
  recallFailed(): void;
}

export const ErrorContainer: React.FC<IErrorContainerProps> = ({ isError, recallFailed }) => {
  if (!isError) {
    return null;
  }

  return <ErrorComponent recallFailed={recallFailed} />;
};
